import { Typography, Container } from "@mui/material";
import { Marksome, References } from "react-marksome";
import DownloadGuides from "./DownloadGuides";
import SpaceBarPicture from "../../assets/images/keyboard_space.jpg";

const Instructions = (props: { userCode: string }) => {
  const {
    testStart,
    testStarter,
    examiner,
    pause,
    wordNumber,
    varIntervals,
    varPauseLength,
    varSoundRecording,
    varTestTaker,
  } = text;
  return (
    <Container disableGutters sx={styles.rootContainer}>
      <Typography sx={styles.subTitle}>Juhend</Typography>
      <Typography paragraph>
        <Marksome text={testStart} references={textReferences} />
      </Typography>
      <Typography paragraph>
        <Marksome text={testStarter} references={textReferences} />
      </Typography>
      <Typography paragraph>
        <Marksome text={examiner} references={textReferences} />
      </Typography>
      <Typography paragraph>
        <Marksome text={pause} references={textReferences} />
      </Typography>
      <Typography paragraph>
        <Marksome text={wordNumber} references={textReferences} />
      </Typography>
      <Typography paragraph>
        <Marksome text={varTestTaker} references={textReferences} />
      </Typography>
      <Typography paragraph>
        <Marksome text={varIntervals} references={textReferences} />
      </Typography>
      <Typography paragraph>
        <Marksome text={varPauseLength} references={textReferences} />
      </Typography>
      <Typography>
        <Marksome text={varSoundRecording} references={textReferences} />
      </Typography>
      <DownloadGuides userCode={props.userCode} />
    </Container>
  );
};

export default Instructions;

const styles = {
  subTitle: {
    display: "flex",
    justifyContent: "center",
    fontWeight: 700,
    color: "black",
    pt: "6%",
    pb: "5%",
  },
  rootContainer: {
    backgroundColor: "white",
    borderRadius: "20px",
    pb: "5%",
    px: "5%",
  },
};

const text = {
  testStart:
    "**Test algab** siis, kui vajutate nupule „Soorita test“. Enne testi sooritamist tutvuge juhendiga " +
    "ning veenduge, et hindamisleht on välja prinditud, pastakas käes ning soovi korral " +
    "diktofon sisse lülitatud.",
  testStarter: "**Testi sooritaja**: istute arvuti ekraani ees ning loete sõnu, mis ekraanile ilmuvad.",
  examiner:
    "**Testi läbiviija / hindaja**: istute nii, et arvutiekraan ei oleks teile nähtav. Märgite linnukese " +
    "või ristiga, mis sõna teie arvates rääkija ütles. Ärge küsige üle ega andke märku, et olete või ei " +
    "ole sõnast aru saanud.",
  pause:
    "**Ekstrapausi** võimalus. Kui testi läbiviimise ajal tekib vajadus pausi teha (keegi või miski segab ootamatult " +
    "vahele), vajutage [tühikuklahvile][1]. Testi jätkamiseks vajutage tühikuklahvile uuesti.",
  wordNumber:
    "**Sõna number**. Iga ekraanile ilmuva sõna all on number, mis vastab hindamisjuhendis oleva sõnade allkogumi" +
    "numbrile. Kaks esimest sõna (RIIUL, KAPSAS) on nummerdamata, sest need on mõeldud katsetamiseks ja ei " +
    "lähe arvesse. Kui tahate olla kindel, mis järjekorranumbriga sõna parasjagu patsient ütleb, siis vajutage " +
    "pausile ja küsige patsiendi käest, mis number tal ekraanil sõna all on.",
  varTestTaker:
    "**Testi sooritaja**: siia pange patsiendi tinglik nimi. Isikuandmete kaitse eesmärgil ärge " +
    "pärisnime kasutage!",
  varIntervals:
    "**Intervallid**: vaikimisi esitatakse sõnu 4-sekundilise intervalliga. Soovi korral " +
    "võite intervalli muuta (min 2 sek, max 10 sek).",
  varPauseLength:
    "**Pausi pikkus**: vaikimisi on testi keskel üks 30-sekundiline paus. Soovi " +
    "korral võite pausi pikkust muuta (kuni 120 sek) või pausist loobuda (sel juhul pange pausi pikkuseks 0 sek).",
  varSoundRecording: "**Salvesta heli**: Vaikimisi on testi heli salvestamine väljalülitatud.",
};

const textReferences: References = {
  1: () => (
    <a href={SpaceBarPicture} target="_blank" rel="noreferrer">
      tühikuklahvile
    </a>
  ),
};
